import type { Cluster } from '@/lib/cluster';

import auFlag from './au.svg';
import usFlag from './us.svg';

/** Flutter's own two assets (`avatar_menu.dart:402-406`), copied rather than redrawn. */
const FLAGS: Record<Cluster, string> = { au: auFlag, us: usFlag };

/**
 * A region's flag, 20px as Flutter draws it. Hidden from a screen reader: what it stands in
 * for is named by the control it sits in.
 */
export function Flag({ cluster }: { cluster: Cluster }) {
  return (
    <img
      src={FLAGS[cluster]}
      alt=""
      aria-hidden="true"
      className="h-5 w-5 shrink-0 rounded-[2px] object-cover"
    />
  );
}
